/*
 * @Author: DESKTOP-T047RUH\Administrator 13723683480@163.com
 * @Date: 2024-01-31 11:17:48
 * @LastEditors: “lihui” 13723683480@163.com
 * @LastEditTime: 2024-10-29 10:36:40
 * @FilePath: \an-pc\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import VueSimpleVerify from 'vue-simple-verify'
import '../node_modules/vue-simple-verify/dist/vue-simple-verify.css'
import '@/assets/styles/common.less';
import '@/assets/iconfont/iconfont.css';

import plugin from './plugin';
Vue.use(plugin);
Vue.component('vue-simple-verify', VueSimpleVerify)

Vue.config.productionTip = false;

var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
link.type = 'image/x-icon';
link.rel = 'shortcut icon';
if(process.env.NODE_ENV == 'development'){
	document.title = '无我';
	link.href = 'https://f.auto-axc.com/images/favicon.ico';
}else{
	document.title = '安信查';
	link.href = 'https://f.auto-axc.com/images/prod_favicon.ico';
}
document.getElementsByTagName('head')[0].appendChild(link);


new Vue({
	router,
	store,
	render: h => h(App),
	beforeCreate() {
		Vue.prototype.$bus = this;
	},
}).$mount('#app');
